<template>
  <div id="article-create" class="col-12 row mx-0 px-0">
    <article-content
      :article-id="articleId"
      @edited="edited"
      @updated="updateCurrentArticle"
      @cover="setPreviewCover"
    >
    </article-content>
    <article-preview
      :cover-url="coverUrl"
      :content="previewContent"
    ></article-preview>
  </div>
</template>

<script>
import ArticleContent from "@/components/admin/view/article/create/ContentDetail"
import ArticlePreview from "@/components/admin/view/article/create/PreviewPanel"

export default {
  components: {
    ArticleContent,
    ArticlePreview,
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit === true) {
      // eslint-disable-next-line no-alert
      const answer = window.confirm(
        "เนื้อหาที่แก้ไขยังไม่ถูกบันทึก... คุณต้องการจะออกจากหน้านี้ใช่หรือไม่?",
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  data() {
    return {
      title: "",
      contentHtml: "",
      coverUrl: "",
      isEdit: false,
    }
  },
  computed: {
    previewContent() {
      return {
        title: this.title,
        body: this.contentHtml,
        type: this.articleType,
      }
    },
    articleId() {
      return this.$route.params.articleId
    },
    articleType() {
      return this.$route.params.articleType
    },
  },
  methods: {
    edited(value) {
      this.isEdit = value
    },
    setPreviewCover(cover) {
      this.coverUrl = cover.url
    },
    updateCurrentArticle(editedContent) {
      this.title = editedContent.title
      this.contentHtml = editedContent.content
    },
  },
}
</script>

<style scoped></style>
